<template>
  <main class="main main--has-floating-buttons">
    <tabable-card id="notifications" cols="12">
      <tabable-card-content :title="$t('pageNotifications.unreadNotifications')">
        <hm-card-inner :full-size="true">
          <hm-table columns="3" grid-template-columns="auto 15rem" min-width="600px">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageNotifications.notificationTitle') }}</div>
              <div class="hm-table__th text-right">{{ $t('pageNotifications.notificationTime') }}</div>
            </template>
            <template slot="default">
              <template v-for="notification in unreadNotifications">
                <div v-if="notification.type != null" :title="$t(`NotificationType.${notification.type}`, notification.params)" class="hm-table__td privacy--blur" @click="onClickNotification(notification)">
                  {{ $t(`NotificationType.${notification.type}`, preProcessNotificationParams(notification.type, notification.params)) }}
                </div>
                <div v-else :title="notification.message" class="hm-table__td privacy--blur" @click="onClickNotification(notification)">
                  {{ notification.message }}
                </div>
                <div class="hm-table__td text-right" @click="onClickNotification(notification)">
                  {{ notification.dateTime | toDuration }}
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content :title="$t('pageNotifications.readNotifications')">
        <hm-card-inner :full-size="true">
          <hm-table columns="2" grid-template-columns="auto 15rem" min-width="600px">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageNotifications.notificationTitle') }}</div>
              <div class="hm-table__th text-right">{{ $t('pageNotifications.notificationTime') }}</div>
            </template>
            <template slot="default">
              <template v-for="notification in readNotifications">
                <div v-if="notification.type != null" :title="$t(`NotificationType.${notification.type}`, notification.params)" class="hm-table__td privacy--blur" @click="onClickNotification(notification)">
                  {{ $t(`NotificationType.${notification.type}`, preProcessNotificationParams(notification.type, notification.params)) }}
                </div>
                <div v-else :title="notification.message" class="hm-table__td privacy--blur" @click="onClickNotification(notification)">
                  {{ notification.message }}
                </div>
                <div class="hm-table__td text-right" @click="onClickNotification(notification)">
                  {{ notification.dateTime | toDuration }}
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageNotifications.actions.markAllAsRead')" icon="save" color="mint" @click="onClickMarkAllAsRead" />
    </hm-floating-buttons>
  </main>
</template>


<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse } from 'lodash';
import HmCardInnerLine from '../lib/layout/HmCardInnerLine';
import HmCardInner from '../lib/layout/HmCardInner';
import uuid from 'uuid';
import HmCol from '../lib/layout/HmCol';
import HmInput from '../lib/inputs/HmInput';
import ContenteditableDiv from '../lib/util/ContenteditableDiv';
import NotificationMixin from '../../mixins/NotificationMixin';
import HmTable from '../lib/table/HmTable';
import TabableCard from '../lib/layout/TabableCard';
import TabableCardContent from '../lib/layout/TabableCardContent';

export default {
  name: 'PageNotifications',
  components: { TabableCardContent, TabableCard, HmTable, ContenteditableDiv, HmCardInner, HmInput, HmCol },

  mixins: [HotelmeisterMixin, NotificationMixin],

  data() {
    return {
      unreadNotifications: [],
      readNotifications: [],
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.updateReadNotifications();
    this.updateUnreadNotifications();
  },

  methods: {
    onClickMarkAllAsRead() {
      this.markAllAsRead().then(() => {
        this.updateReadNotifications();
        this.updateUnreadNotifications();
      });
    },
    updateReadNotifications() {
      this.axios.get(this.serviceUrls.hotel.unreadNotifications(this))
        .then((response) => {
          this.unreadNotifications = response.data.data;
        });
    },
    updateUnreadNotifications() {
      this.axios.get(this.serviceUrls.hotel.readNotifications(this))
        .then((response) => {
          this.readNotifications = response.data.data;
        });
    },
    onClickNotification: function (notification) {
      this.openEntity(
        isNil(notification.entityIdentifier) ? null : notification.entityIdentifier.type,
        isNil(notification.entityIdentifier) ? null : notification.entityIdentifier.id,
        notification.id,
      )
        .then((response) => {
          this.updateReadNotifications();
          this.updateUnreadNotifications();
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/PageNotifications.vue